// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"ce9efe6f","242":"c23be04a","295":"4508edf1","454":"ec06eec5","469":"0d556fe2","715":"5d654931","718":"209deb94","978":"8690d266"}[chunkId] + ".css";
};